<script lang="ts" setup>
import VersionManagementTab from "@/views/shared/components/version-management/VersionManagementTab.vue";

interface Props {
  project: any;
  isPublisherMasterProject?: boolean;
}

const props = defineProps<Props>();
</script>

<template>
  <VersionManagementTab
    :product-id="project?.publisherProductId ?? ''"
    :master-project-id="project?.id ?? ''"
    entity-type="project"
    :is-publisher-master-project="isPublisherMasterProject"
  />
</template>
